import { SearchFilterTag } from '@/components';
import {
  type SharedSearchFormKeys,
  type SharedSearchFormType,
  getSearchKeyword,
} from '@/features/search/_utils/projects-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const TextSearchTag: FC = () => {
  const { control, setValue } = useFormContext<SharedSearchFormType>();
  const searchKeyword = useWatch({
    control,
    name: 'q' satisfies SharedSearchFormKeys,
  });
  const isSearchTargetProjectName = useWatch({
    control,
    name: 'isSearchTargetProjectName',
  });

  const value = getSearchKeyword(searchKeyword, isSearchTargetProjectName);
  if (!value) {
    return null;
  }

  return (
    <SearchFilterTag
      label={value}
      closable={true}
      onClose={() => {
        setValue('q' satisfies SharedSearchFormKeys, null);
        setValue(
          'isSearchTargetProjectName' satisfies SharedSearchFormKeys,
          false,
        );
      }}
    />
  );
};
